module.exports = __webpack_public_path__ + "static/media/fg-fish-palm.8893de7c.svg";